import React from 'react'
import { makeStyles, styled } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
}));

export default function Button(props) {
    const classes = useStyles();

    const StyledButton = styled('button') (({ theme }) => ({
        background: props.background,
        color: props.color ?? '#fff',
        border: '1px solid' + props.color,
        padding: '1.3rem 1.6rem',
        borderRadius: '2rem',
        fontFamily: "Loew Next Arabic",
        fontSize: '1.6rem',
        transition: 'all 0.5s ease-in-out',
        [theme.breakpoints.down("600")]: {
            fontSize: '2.4rem',
            padding: '1.9rem 1.9rem'
        }
    }))

    return (
        <div className={classes.root}>
            <StyledButton onClick={props.onClick} variant={props.variant} color={props.color}>{props.text}</StyledButton>
        </div>
    );
}